module.exports = __webpack_public_path__ + "img/hedi-scale.3b4cd897.png";